<template>
    <div>
        <b-form-group
            label="Prompt"
            label-for="prompt"
        >

            <TipTap
                v-model="editable_content.question_prompt"
                :class="{'is-invalid': validating && !editable_content.question_prompt}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question_prompt', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question_prompt ? false : null">
                Prompt is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Matching Sets"
            label-for="matching_sets"
        >
            <draggable
                v-if="editable_content.answer_pairs && editable_content.answer_pairs.length"
                v-model="editable_content.answer_pairs"
                handle=".drag-handle"
                tag="b-list-group"
                class="mb-2"
            >
                <b-list-group-item v-for="(answer, index) in editable_content.answer_pairs" :key="index">
                    <div class="d-flex align-items-center">
                        <div v-if="editable_content.answer_pairs && editable_content.answer_pairs.length > 1" class="mr-3">
                            <div class="drag-handle">
                                <font-awesome-icon :icon="['far', 'arrows-v']" />
                            </div>
                        </div>
                        <div class="row align-items-center mr-3 flex-grow-1">
                            <div v-if="answer.left" class="col-5 d-flex align-items-center">
                                <div class="mr-3">
                                    <b-form-radio v-model="answer.left.type" value="text" @change="answer.left.text = null">Text</b-form-radio>
                                    <b-form-radio v-model="answer.left.type" value="image" @change="answer.left.image = null">Image</b-form-radio>
                                </div>
                                <div class="flex-grow-1">
                                    <div v-if="answer.left.type == 'text'">
                                        <b-form-textarea v-model="answer.left.text" :state="validating && !answer.left.text ? false : null" />
                                        <b-form-invalid-feedback :state="validating && !answer.left.text ? false : null">
                                            Text is required
                                        </b-form-invalid-feedback>
                                    </div>
                                    <div v-if="answer.left.type == 'image'">
                                        <div v-if="answer.left.image" class="mb-2">
                                            <SbpMedia
                                                :media="answer.left"
                                                :type="'matching'"
                                                :key="answer.left.image"
                                                @update="update($event, answer, 'left')"
                                                @removeImage="removeImage(answer, 'left')"
                                            />
                                        </div>
                                        <div class="d-flex">
                                            <div>
                                                <b-dropdown
                                                    size="sm"
                                                    variant="outline-primary"
                                                    dropup
                                                    right
                                                >
                                                    <template #button-content>
                                                        <font-awesome-icon :icon="['fad', 'plus-square']" class="mr-2"/><span v-if="!answer.left.image">Select Image</span><span v-else>Select Different Image</span>
                                                    </template>
                                                    <b-dropdown-item @click.prevent="selectImage(answer, 'left', 'sbp')">
                                                        <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Media Image
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 text-center">
                                <font-awesome-icon :icon="['fad', 'exchange']" />
                            </div>
                            <div v-if="answer.right" class="col-5 d-flex align-items-center">
                                <div class="mr-3">
                                    <b-form-radio v-model="answer.right.type" value="text" @change="answer.right.text = null">Text</b-form-radio>
                                    <b-form-radio v-model="answer.right.type" value="image" @change="answer.right.image = null">Image</b-form-radio>
                                </div>
                                <div>
                                    <div v-if="answer.right.type == 'text'">
                                        <b-form-textarea v-model="answer.right.text" :state="validating && !answer.right.text ? false : null" />
                                        <b-form-invalid-feedback :state="validating && !answer.right.text ? false : null">
                                            Text is required
                                        </b-form-invalid-feedback>
                                    </div>
                                    <div v-if="answer.right.type == 'image'">
                                        <div v-if="answer.right.image" class="mb-2">
                                            <SbpMedia
                                                :media="answer.right"
                                                :type="'matching'"
                                                :key="answer.right.image"
                                                @update="update($event, answer, 'right')"
                                                @removeImage="removeImage(answer, 'right')"
                                            />
                                            <b-form-invalid-feedback :state="validating && !answer.right.image ? false : null">
                                                Image is required
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div>
                                            <div class="d-flex">
                                                <div>
                                                    <b-dropdown
                                                        size="sm"
                                                        variant="outline-primary"
                                                        dropup
                                                        right
                                                    >
                                                        <template #button-content>
                                                            <font-awesome-icon :icon="['fad', 'plus-square']" class="mr-2" /><span v-if="!answer.right.image">Select Image</span><span v-else>Select Different Image</span>
                                                        </template>
                                                        <b-dropdown-item @click.prevent="selectImage(answer, 'right', 'sbp')">
                                                            <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Media Image
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <b-link class="text-danger" @click="removeSet(index)">
                                <font-awesome-icon :icon="['far', 'minus']" />
                            </b-link>
                        </div>
                    </div>

                    <add-related-media-modal
                        v-model="answer.show_add_related_media_modal"
                        :type="'image'"
                        @link="linkAsset($event, answer)"
                        @hide="answer.show_add_related_media_modal = false"
                    />

                </b-list-group-item>
            </draggable>

            <b-form-invalid-feedback class="mb-2" :state="validating && (!editable_content.answer_pairs || editable_content.answer_pairs && !editable_content.answer_pairs.length) ? false : null">
                At least 1 set is required
            </b-form-invalid-feedback>

            <b-btn size="sm" variant="outline-primary" @click="addSet">
                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Matching Set
            </b-btn>

        </b-form-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import SbpMedia from '@/components/media/SbpMedia'

export default {
    data: () => ({
        editable_content: {
            answer_pairs: []
        },

        side: null
    }),
    props: [
        'question'
    ],
    components: {
        draggable,
        TipTap: () => import('@/components/tiptap/TipTap'),
        AddRelatedMediaModal,
        SbpMedia
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        addSet () {
            if (!this.editable_content.answer_pairs) {
                this.editable_content.answer_pairs = []
            }

            this.editable_content.answer_pairs.push({
                left: {
                    type: 'text'
                },
                right: {
                    type: 'text'
                }
            })
        },
        removeSet (index) {
            if (this.editable_content.answer_pairs) {
                this.editable_content.answer_pairs.splice(index, 1)
            }
        },
        selectImage (answer, side, media_library) {
            if (media_library == 'sbp') {
                this.$set(answer, 'show_add_related_media_modal', true)
            }

            this.side = side
        },
        resetMedia(answer) {
            let type = answer.type;
            answer = {};
            answer.type = type;
            return answer
        },
        removeImage(answer, side) {
            this.$swal({
                html: 'Are you sure you want remove this image?',
                showCancelButton: true,
                confirmButtonText: 'Remove Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$set(answer, side, {type: 'image'})
                }
            })
        },
        update (media, answerContainer, side) {
            // Clone the answer data already present, so we can set it all below.
            let answer = Object.assign({}, answerContainer[side])

            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                answer.merlin_id = !isNaN(merlinId) ? merlinId : null
                answer.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                answer.related_media_id = !isNaN(mediaId) ? mediaId : null
                answer.media_id = !isNaN(mediaId) ? mediaId : null
            }
            answer.type = media.type
            answer.image = media.src ? media.src : media.image
            answer.alt = media.alt
            answer.credit = media.credit
            answer.description = media.description
            answer.caption = media.caption
            answer.name = media.name ? media.name : (media.title ? media.title : '')

            // Adding properties that did not exist at the time of instantiation is not reactive.
            // so we reset the answer data with all of its properties (new and old) to force the changes to bubble up.
            this.$set(answerContainer, side, answer)
        },
        linkAsset (asset, answer) {
            let merlinId = !isNaN(parseInt(asset.merlinid)) ? parseInt(asset.merlinid) : null  // get merlinId as a number if it exists
            if (this.side == 'left') {
                answer.left = this.resetMedia(answer.left);
                if (asset.url) { // From SBP Library
                    answer.left.image = asset.url
                    answer.left.related_media_id = asset.id
                    answer.left.credit = asset.credit
                    answer.left.description = asset.description
                    answer.left.caption = asset.caption
                    answer.left.title = asset.title
                }
                else if (asset.thumbpermlink) {
                    answer.left.image = asset.thumbpermlink
                    answer.left.merlin_id = merlinId
                } else {
                    answer.left.image = asset.previewpermlink
                    answer.left.merlin_id = merlinId
                }
                if (answer.left.type == 'image') {
                    answer.left.alt = asset.alt ? asset.alt : asset.headline
                    answer.left.title = asset.title
                }
            }
            if (this.side == 'right') {
                answer.right = this.resetMedia(answer.right);
                if (asset.url) { // From SBP Library
                    answer.right.image = asset.url
                    answer.right.related_media_id = asset.id
                    answer.right.credit = asset.credit
                    answer.right.description = asset.description
                    answer.right.caption = asset.caption
                    answer.right.title = asset.title
                }
                else if (asset.thumbpermlink) {
                    answer.right.image = asset.thumbpermlink
                    answer.right.merlin_id = merlinId
                } else {
                    answer.right.image = asset.previewpermlink
                    answer.right.merlin_id = merlinId
                }
                if (answer.right.type == 'image') {
                    answer.right.alt = asset.alt ? asset.alt : asset.headline
                    answer.right.title = asset.title
                }
            }
            this.side == null

            this.$set(answer, 'show_add_related_media_modal', false)
        },
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        }
    }
}
</script>
